// All amounts are integer micro-units (1e-6 USDG) carried as decimal strings or bigint.
// Never convert to a JS number.

export const TOKEN_SYMBOL = "USDG";
export const TOKEN_DECIMALS = 6;

const DEC = /^(0|[1-9][0-9]*)$/;

export function parseMicro(value: string | bigint): bigint {
  if (typeof value === "bigint") return value;
  if (!DEC.test(value)) throw new Error(`not an integer micro amount: ${value}`);
  return BigInt(value);
}

/** Format micro-units as a fixed 6-decimal string, e.g. 50000n -> "0.050000". */
export function formatMicro(value: string | bigint, opts: { trim?: boolean } = {}): string {
  const v = parseMicro(value);
  const neg = v < 0n;
  const abs = neg ? -v : v;
  const whole = abs / 1_000_000n;
  let frac = (abs % 1_000_000n).toString().padStart(6, "0");
  if (opts.trim) {
    frac = frac.replace(/0+$/, "");
    if (frac.length < 2) frac = frac.padEnd(2, "0");
  }
  const wholeStr = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${neg ? "-" : ""}${wholeStr}.${frac}`;
}

/** Parse a user-entered decimal like "0.05" into micro-units. Rejects > 6 decimals. */
export function decimalToMicro(input: string): bigint | null {
  const s = input.trim().replace(/,/g, "");
  const m = /^(\d+)(?:\.(\d{0,6}))?$/.exec(s);
  if (!m) return null;
  const whole = BigInt(m[1]!);
  const frac = BigInt((m[2] ?? "").padEnd(6, "0") || "0");
  return whole * 1_000_000n + frac;
}

export function sumMicro(values: Array<string | bigint>): bigint {
  return values.reduce<bigint>((acc, v) => acc + parseMicro(v), 0n);
}

export const LIMITS = {
  minRunMicro: 50_000n,
  maxRunMicro: 10_000_000n,
  pilotEscrowCapMicro: 500_000_000n,
  computeMicroPerMillionFuel: 50n,
  platformFeeBps: 1000n,
  maxNodes: 12,
  maxInvocations: 32,
  maxInputBytes: 1_048_576,
} as const;
